import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Protected Route component for role-based access
function ProtectedRoute({ children, allowedRoles }) {
  const { user } = useAuth();
  const location = useLocation();
  
  if (!user) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '60vh',
        padding: '2rem',
        textAlign: 'center'
      }}>
        <h1 style={{ color: '#ef4444', marginBottom: '1rem' }}>Access Denied</h1>
        <p style={{ color: '#6b7280', marginBottom: '2rem' }}>
          You don't have permission to access this page. Please contact your administrator.
        </p>
        <p style={{ color: '#6b7280' }}>
          Required roles: {allowedRoles.join(', ')}
        </p>
      </div>
    );
  }

  return children;
}

export default ProtectedRoute; 